import {Notifications} from '@mantine/notifications';
import Head from 'next/head';
import {useRouter} from 'next/router';
import {TITLE_SUFFIX} from '../../../config/constants';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import type {CommunityTopic} from '../../../core/entities/community/schema';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';
import {CommunityDetailPcComponent} from './Container/CommunityDetailPcComponent';
import {SpComponent} from './Container/Presenter/spComponent';
import {TagList} from './Container/TagList';

type Props = {
  topic: CommunityTopic;
  communityNickname: string;
  isSignedIn: boolean;
  isStudentVerificationRequired: boolean;
};

export const CommunityDetailPage: React.FC<Props> = ({
  topic,
  communityNickname,
  isSignedIn,
  isStudentVerificationRequired,
}: Props) => {
  const TITLE = `${topic.title}${TITLE_SUFFIX}`;
  const DESCRIPTION = topic.body.slice(0, 70);
  const KEYWORD =
    '外資,就活,インターンシップ,新卒採用,会社説明会,コラム,ES・体験記,投資銀行,コンサル,商社';
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.asPath)}`;
  const {isPC} = useMediaQuery();
  if (isPC === undefined) {
    return null;
  }

  return (
    <>
      <Head>
        <title key="title">{TITLE}</title>
        <meta key="og:title" property="og:title" content={TITLE} />
        <meta key="description" property="description" content={DESCRIPTION} />
        <meta
          key="og:description"
          property="og:description"
          content={DESCRIPTION}
        />
        <meta key="keywords" name="keywords" content={KEYWORD} />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <meta name="robots" content="noindex" />
      </Head>
      <Notifications position={'top-right'} />
      {/* 左カラム */}
      {isPC && (
        <div className="w-[200px] mr-16 sticky">
          <TagList />
        </div>
      )}
      {/* 中央カラム */}
      <div className="w-full pc:w-[880px]">
        {isPC ? (
          <CommunityDetailPcComponent
            topic={topic}
            communityNickname={communityNickname}
            isSignedIn={isSignedIn}
            isStudentVerificationRequired={isStudentVerificationRequired}
          />
        ) : (
          <SpComponent />
        )}
      </div>
    </>
  );
};
